import React, { Component } from "react";
import { Col, Row } from "reactstrap"; 
import { GrCheckboxSelected as BsCheck, GrCheckbox as BsSquare } from "react-icons/gr";

import { 
  SlButton,
  SlBusyIndicator,
  SLCardSelectable,
  SlConfirmationModal,
} from "../editors";
import {
  metadataService,
  FinancialApi,
} from "../../_services";
import { connect } from "react-redux";

class FinancialInfoView extends Component {
  static displayName = FinancialInfoView.name;

  constructor(props) {
    super(props);

    
    this.state = {
      steps: [],
      currentStep: "",
      formValue: {},
      selectedId : null,
      selectedItem : null,
      isBusy: false,
      showConfirmation: false,
    };
    this.onSelectFinancialInfo = this.onSelectFinancialInfo.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onEdit = this.onEdit.bind(this);
  }
  componentDidMount() {}
  onSelectFinancialInfo(financial) {
    let { selectedId } = this.state;
    if (selectedId == financial.id) {
      this.setState({
        selectedItem: null,
        selectedId: null,
      });
    } else {
      this.setState({
        selectedItem: financial,
        selectedId: financial.id,
      });
    }
  }
  onAdd() {
    if (this.props.onAdd) {
      this.props.onAdd();
    }
  }
  onEdit() {
    const {selectedItem} = this.state;
    if (this.props.onEdit && selectedItem != null) {
      this.props.onEdit(selectedItem);
    }
  }
  onRemove() {
    const { selectedItem } = this.state;
    if (this.props.onRemove && selectedItem != null) {
      this.props.onRemove(selectedItem);
    }
    this.setState({showConfirmation: false, selectedItem : null , selectedId : null})
  }
  render() {
    const { employers, incomes , showOnAdd} = this.props;
    const {
      isBusy,
      selectedId,
      showConfirmation,
    } = this.state;

    return (
      <div>
        <div>
          <SlBusyIndicator visible={isBusy} />
          <SlConfirmationModal
            visible={showConfirmation}
            onCancel={() => this.setState({ showConfirmation: false })}
            onConfirm={() => this.onRemove()}
          />
          {(employers || incomes) &&
            [...employers, ...incomes].filter(s=>s.isDelete !== true).map((source) => {
              return (
                <SLCardSelectable
                  className="ml-3 mb-3"
                  name="financials"
                  value={source.id}
                  selected={selectedId == source.id}
                  onChange={(e) => this.onSelectFinancialInfo(source)}
                  cardBody={
                    source.primaryIncome ===
                    FinancialApi.PRIMARY_INCOME_SOURCE_NOTEMPLOYED ? (
                      <div>
                        {" "}
                        <p>
                          {metadataService.formatMoney(source.amount || 0)}{" "}
                          {
                            metadataService.getLookupAsHashMap(
                              "incomeFrequency"
                            )[4]
                          }
                        </p>
                      </div>
                    ) : (
                      <div>
                        <p>
                          {metadataService.formatMoney(source.incomePerPeriod)}{" "}
                          {source.payFrequency
                            ? metadataService.getLookupAsHashMap(
                                "incomeFrequency"
                              )[source.payFrequency]
                            : ""}
                        </p>
                        <p>
                          { metadataService.formatDuration(source.years, source.months) }
                        </p>
                        <p>{metadataService.formatAddress(source.address1, source.address2, source.city, source.state, source.postalCode)}</p>
                        <p>{metadataService.formatPhoneNumber(source.workNumber)}</p>
                      </div>
                    )
                  }
                  title={
                    source.primaryIncome ===
                    FinancialApi.PRIMARY_INCOME_SOURCE_NOTEMPLOYED ? (
                      <p>
                        {source.otherIncomeSource
                          ? metadataService.getLookupAsHashMap(
                              "otherIncomeSource"
                            )[source.otherIncomeSource]
                          : ""}
                        {selectedId == source.id && (
                          <span className="float-right">
                            <BsCheck />
                          </span>
                        )}
                        {selectedId !== source.id && (
                          <span className="float-right">
                            <BsSquare />
                          </span>
                        )}
                      </p>
                    ) : (
                      <p>
                        {source.employerName}
                        {selectedId == source.id && (
                          <span className="float-right">
                            <BsCheck />
                          </span>
                        )}
                        {selectedId !== source.id && (
                          <span className="float-right">
                            <BsSquare />
                          </span>
                        )}
                      </p>
                    )
                  }
                />
              );
            })}
        </div>
        <Row className="justify-content-center text-center">
          <Col>
            {showOnAdd && <span><SlButton  name="Add" onClick={this.onAdd}></SlButton>{" "}</span>}
            <SlButton disabled={selectedId == null} onClick={this.onEdit} name="Edit"></SlButton>{" "}
            <SlButton
              disabled={selectedId == null}
              name="Remove"
              onClick={() => this.setState({ showConfirmation: true })}
            ></SlButton>
          </Col>
        </Row>
      </div>
    );
  }
}

FinancialInfoView.propTypes = {
   
};

function mapStateToProps(state) {
  const { loggedIn } = state.authentication;
  const { steps, currentStep } = state.users;

  const {
   financials,
   employers,
   incomes,
  } = state.financialInfo;

  return {
    loggedIn,
    steps,
    currentStep,
    financials,
    employers,
    incomes,
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
  };
};

const connectedFinancialInfo = connect(mapStateToProps,mapDispatchToProps)(FinancialInfoView);
export { connectedFinancialInfo as FinancialInfoView };
